import { fromJS } from 'immutable';

import { SUCCESS, START, ERROR } from '@modules/appraisal/actions/global';
import * as actions from '../actions/stratifications';

import { fetchingState } from '@constants';

const initialState = {
  runs: {
    data: [],
    state: null,
    pagination: {
      count: 0,
      page: 1,
      rowsPerPage: 40,
      rowsPerPageOptions: [40, 80, 120, 1000],
    }
  },
};

export default (state = fromJS(initialState), action) => {
  switch (action.type) {
    case actions.FETCH_STRATIFICATION_RUNS[START]:
      return state.setIn(['runs', 'state'], fetchingState.FETCHING);
    case actions.FETCH_STRATIFICATION_RUNS[SUCCESS]:
      return state
        .setIn(['runs', 'state'], fetchingState.LOADED)
        .setIn(['runs', 'data'], fromJS(action.data ? action.data.results : []))
        .setIn(
          ['runs', 'pagination', 'count'],
          action.data ? action.data.results.length : 0,
        );
    case actions.FETCH_STRATIFICATION_RUNS[ERROR]: {
      return state.setIn(['runs', 'state'], fetchingState.ERROR);
    }
    case actions.CHANGE_PAGE: {
      return state.setIn(['runs', 'pagination', 'page'], action.payload);
    }
    case actions.CHANGE_ROWS_PER_PAGE: {
      return state.setIn(['runs', 'pagination', 'rowsPerPage'], action.payload);
    }
    default:
      return state;
  }
};
